import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, FileText } from "lucide-react";
import { useAppStore } from "lib/store/useAppStore";
import { getProject } from "lib/api/getProject";
import ProjectReportInfoForm from "components/project/ProjectReportInfoForm";
import ProjectReportEditorModal from "./detail/components/ProjectReportEditorModal";
import "css/projectSettings.css";
import "css/projectWorkspace.css";

export default function ProjectReportPage() {
  const { project_id: projectId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.search) navigate({ pathname: location.pathname, search: "", hash: location.hash }, { replace: true });
  }, [location.pathname, location.search, location.hash, navigate]);
  const { t } = useTranslation();
  const user = useAppStore(state => state.user);
  const setLastSelectedProject = useAppStore(state => state.setLastSelectedProject);
  const [project, setProject] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  const reportForm = useMemo(() => project ? { ...project,
    period_start: String(project.period_start ?? "").slice(0, 10),
    period_end: String(project.period_end ?? "").slice(0, 10),
  } : null, [project]);
  useEffect(() => {
    let active = true;
    setProject(null); setLoading(true); setError("");
    getProject(projectId).then(result => {
      if (!active) return;
      if (!result.success || !result.project) { setError(result.message || "프로젝트를 불러오지 못했습니다."); return; }
      setProject(result.project);
      setLastSelectedProject(projectId, result.project.project_name);
    }).catch(() => { if (active) setError("프로젝트를 불러오지 못했습니다."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [projectId, retry, setLastSelectedProject]);
  return <section className="content projectSettingsPage projectReportPage">
    <div className="projectSettings__heading">
      <div><h2><FileText size={21} aria-hidden="true" /> 보고서</h2><p>기재 정보를 확인하고 종류와 출력 형식을 선택하세요.</p></div>
      <Link className="projectSettings__secondary" to={`/project/${projectId}`}><ArrowLeft size={16} aria-hidden="true" /> 파일 목록으로</Link>
    </div>
    {loading ? <p role="status">정보를 불러오는 중…</p> : error ? <div role="alert"><p>{error}</p><button className="projectSettings__secondary" onClick={() => setRetry(value => value + 1)}>다시 불러오기</button></div> : project && <>
      <ProjectReportInfoForm key={projectId} projectId={projectId} project={project} onSaved={setProject} />
      <ProjectReportEditorModal key={`builder:${projectId}`} open embedded projectId={projectId}
        userId={user?.id} project={project} form={reportForm} files={[]} t={t} />
    </>}
  </section>;
}
